import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Grid} from 'views/components';
import {CaregiverAutocomplete} from 'views/module';

import {translate} from 'views/module';

const CaregiverData = (props) => {
  const newEvent = props.newEvent;
  const updateCaregiverData = props.updateCaregiverData;
  const setIsStepValid = props.setIsStepValid;

  const caregiverData = newEvent?.caregiverData || {};

  const caregiver = caregiverData.caregiver || null;

  const updateCaregiver = (newValue) => {
    updateCaregiverData((e) => {
      return {
        ...e,
        caregiver: newValue,
      };
    });
  };

  React.useEffect(() => {
    setIsStepValid(!!(caregiver));
  }, [caregiver]);

  return (
    <Grid container spacing={1}>
      <Grid item md={12} xs={12}>
        <CaregiverAutocomplete
          label={translate('client.ClientDetail.Scheduling.ScheduleDetail.Caregiver.CaregiverSearch')}
          selectedCaregiver={caregiver}
          setSelectedCaregiver={updateCaregiver}
        />
      </Grid>
    </Grid>
  );
};

CaregiverData.propTypes = {
  newEvent: PropTypes.object.isRequired,
  updateCaregiverData: PropTypes.func.isRequired,
  setIsStepValid: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
});
export default connect(mapStateToProps, dispatch)(React.memo(CaregiverData));
